const adminGroupesReducer = (state = {}, action) => {
  switch (action.type) {
    case 'ADMINGROUPES':
      return action.data
    default:
      return state
  }
}

export default adminGroupesReducer
